import React, { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { useModalContext } from "context/modalContext";
import { useTranslation } from "react-i18next";
import { useUser } from "reactfire";
import { useFunctions } from "reactfire";
import { IonLabel, useIonModal } from "@ionic/react";
import { useIonRouter, IonButton } from "@ionic/react";
import { useGame } from "context/gameContext";
import { Md2Loading, Md2LockOpen } from "react-icons-ng/md2";
import GetGameCredits from "components/getGameCredits";

export default function JoinTournament({ item, invited, messageId }) {
  const { status, data: user } = useUser();
  const {
    state: { premium, leagues, gameList, settings, userGameData },
  } = useGame();

  const seasonRef = leagues?.find((league) => league.id === item?.leagueRef);
  const gameRef = gameList?.find((game) => game.id === item?.gameTypeId);
  const leagueLocked = (seasonRef?.premium || gameRef?.premium) && !premium;

  const { t } = useTranslation();
  const router = useIonRouter();
  const { openPaywallModal } = useModalContext();
  const [cardIsLoading, setCardIsLoading] = useState(false);
  const [declineIsLoading, setDeclineIsLoading] = useState(false);
  // let navigate = useNavigate();
  const alreadyJoined = item?.users.some((id) => id === user.uid);

  const functions = useFunctions();
  const joinLeague = httpsCallable(functions, "joinTournament", {
    timeout: 530000,
  });
  const deleteInvite = httpsCallable(functions, "deleteMessage", {
    timeout: 530000,
  });

  async function callJoinLeagueFunction(item, e) {
    e.preventDefault();
    await callJoinLeague(item);
  }

  const [present, dismiss] = useIonModal(
    <GetGameCredits
      closeModal={dismissModal}
      subscribeModalCallBack={callSubscribeModalCallBack}
      joinLeagueCallBack={callJoinLeagueCallback}
    />,
    {
      onDismiss: (data, role) => dismiss(data, role),
    }
  );
  function callSubscribeModalCallBack() {
    dismiss();
    return openPaywallModal();
  }

  async function callJoinLeagueCallback() {
    dismiss();
    await callJoinLeague(item);
  }

  function dismissModal() {
    dismiss();
  }
  async function callJoinLeague(item) {
    setCardIsLoading(true);
    if (leagueLocked) {
      openPaywallModal();
      setCardIsLoading(false);
      return;
    }
    if (
      !premium &&
      settings?.joinByCredit &&
      (!userGameData?.joinLeagueCredits || userGameData?.joinLeagueCredits < 1)
    ) {
      present();
      setCardIsLoading(false);
      return;
    }

    const data = {
      userId: user.uid,
      leagueId: item.id,
    };

    try {
      const result = await joinLeague(data);
      const sanitizedMessage = result.data.text;

      if (invited) {
        await deleteInvite({
          userId: user.uid,
          messageId: messageId,
        });
      }

      router.push("/tabs/tournaments/" + item.id, "forward", "push");
    } catch (error) {
      console.log(error);
      setCardIsLoading(false);
    }
    setCardIsLoading(false);
  }

  const callDeclineLeague = async (item, e) => {
    e.preventDefault();
    setDeclineIsLoading(true);

    let data = {
      userId: user.uid,
      messageId: messageId,
    };

    try {
      await deleteInvite(data);
      setDeclineIsLoading(false);
    } catch (error) {
      console.log(error);
      setDeclineIsLoading(false);
    }
  };

  const userHasJoined = item?.users?.includes(user.uid);
  const isPastDeadline = new Date(item?.deadline?.seconds * 1000) < new Date();

  return (
    <div className="flex space-x-2">
      {invited && (
        <IonButton
          mode="ios"
          color="light"
          fill="outline"
          disabled={declineIsLoading}
          onClick={(e) => callDeclineLeague(item, e)}
          className="m-0 h-8 customButtonNew"
        >
          {t("lobby.card.decline")}
        </IonButton>
      )}
      <IonButton
        mode="ios"
        color="success"
        disabled={
          (isPastDeadline && item?.gameType === 1) ||
          cardIsLoading ||
          alreadyJoined
        }
        onClick={(e) => callJoinLeagueFunction(item, e)}
        className="m-0 h-8 customButtonNew"
      >
        {leagueLocked && <Md2LockOpen className="h-5 w-5 mr-2 text-black" />}
        <IonLabel className="!text-black">
          {" "}
          {!cardIsLoading ? (
            t("lobby.card.join")
          ) : (
            <Md2Loading className="h-6 w-6 animate-spin" />
          )}
        </IonLabel>
      </IonButton>
    </div>
  );
}
